<template>
	<div class="input">
		<InputLabel :label="label" />
		<input
			type="text"
			:class="computedClass"
			:placeholder="placeholder"
			:value="value"
			@input="$emit('input', $event.target.value)"
		/>
		<span class="input__error" v-if="alert">Campo obrigatório.</span>
	</div>
</template>
<script>
import InputLabel from '@/components/shared/InputLabel/InputLabel.vue';
export default {
	name: 'InputText',
	components: {
		InputLabel,
	},
	props: {
		label: {
			type: String,
		},
		value: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		alert: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		computedClass() {
			return {
				input__field: true,
				'input__field--alert': this.alert,
			};
		},
	},
};
</script>
<style lang="scss" scoped>
@import './InputText.scss';
</style>
